/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"
import movies from "./modules/movies"
import genres from "./modules/genres"
import collections from "./modules/collections"
import groups from "./modules/groups"
import languages from "./modules/languages"
import imdb from "./modules/imdb"
import cast from "./modules/cast"
import stories from "./modules/stories"
import users from "./modules/users"
import slider from "./modules/slider"
import Tv from "./modules/tv"
import reels from "./modules/reels"
import auth from "./auth"
Vue.use(Vuex)

export default new Vuex.Store({
    modules:{
      movies,genres,groups,collections,languages,imdb,cast,stories,users,slider,auth,reels,Tv
    },
    getters,
    mutations,
    state,
    actions,
    strict: process.env.NODE_ENV !== 'production'
})
